import { defineComponent as _defineComponent } from 'vue'
import ActivityIndicatorDark from '@@/images/activity-indicator-dark.svg'
import ActivityIndicatorLight from '@@/images/activity-indicator-light.svg'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceActivitySvg',
  props: {
    colorScheme: null
  },
  setup(__props: any) {

const props = __props as {
  colorScheme: 'light' | 'dark'
}



const svgPath = computed((): string => {
  return props.colorScheme === 'light' ? ActivityIndicatorLight : ActivityIndicatorDark
})

return { __sfc: true,props, svgPath }
}

})